import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { GlobalLoaderComponent } from './global-loader/global-loader.component';
import { LoginComponent } from './login/login.component';
import { LogoutComponent } from './logout/logout.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { OfLogoModule } from '../shared/of-logo/of-logo.module';
import { ValidatorsModule } from '../validators/validators.module';

@NgModule({
  declarations: [
    GlobalLoaderComponent,
    LoginComponent,
    LogoutComponent,
    ForgotPasswordComponent,
  ],
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        OfLogoModule,
        ValidatorsModule,
    ],
  exports: [
    GlobalLoaderComponent,
  ]
})
export class PublicModule { }
